import cn from 'classnames';

export function ListPlaceholderLoading({ className }: { className?: string }) {
  return (
    <ul>
      {Array.from({ length: 3 }).map((_, index) => (
        <li
          key={index}
          className={cn(
            'my-1 me-4 ms-6 flex h-[84px] flex-1 animate-pulse gap-x-3 rounded-[12px] bg-white p-3 font-medium text-gray-200',
            className,
          )}
        >
          <div className="h-[40px] w-[40px] rounded-[8px] bg-gray-200" />
          <div className="flex flex-1 flex-col gap-y-1">
            <span className="font-placeholder text-16/100%">name</span>
            <span className="font-placeholder text-16/100%">role</span>
            <span className="font-placeholder text-16/100%">role</span>
          </div>
        </li>
      ))}
    </ul>
  );
}
